import React from "react";
import { IoIosInformationCircle } from "react-icons/io";

const AccountStatusCard = ({message}) => {
  return (
    <div
      style={{
        backgroundColor: "#F0F2F5",
        borderRadius: "0.5rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        fontWeight: "500",
        color: "black",
        width: "100%",
      }}
    >
      <i style={{ padding: "1rem", display: "flex", justifyContent: "start", alignItems: "center", gap: "0.5rem" }}><IoIosInformationCircle style={{ fontSize: "1.8rem", paddingTop: "0.1rem", color: "#e8632b" }} />{message}</i>
    </div>
  );
};

export default AccountStatusCard;
